import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PaymentStep from './paymentStep'
import SignupStep from './signupStep'
import PremiumActive from './premiumActive'
import './styles.css'

class signupModal extends PureComponent {
  render = () => {
    if(!this.props.user.id) return <SignupStep {...this.props} />
    if(!this.props.user.premiumUntil) return <PaymentStep {...this.props} />
    return <PremiumActive {...this.props} />
  }
}

const mapStateToProps = (state: Store) => ({
  loggedIn: state.auth.loggedIn,
  user: state.user
})

export default connect(mapStateToProps)(signupModal)



// WEBPACK FOOTER //
// ./src/modals/signupModal/index.js